module.exports = __webpack_public_path__ + "media/application/images/2018/2018-mail-icon-c86ecab4895785970469033f18c030e4.svg";